import PerfectScrollbar from 'perfect-scrollbar';

const scrollbarSelector = '[data-scrollbar="true"]';

function getScrollbarElements(root) {
	if (!root) return [];

	const elements = root.matches?.(scrollbarSelector) ? [root] : [];
	return elements.concat(Array.from(root.querySelectorAll(scrollbarSelector)));
}

export function initializeScrollbars(root) {
	const isMobile = window.matchMedia('(max-width: 767px)').matches;
	const initializedElements = [];

	const instances = getScrollbarElements(root).reduce(
		(instances, element) => {
			if (element.__perfectScrollbarState || (isMobile && element.hasAttribute('data-skip-mobile'))) {
				return instances;
			}

			const height = element.getAttribute('data-height');
			// Dropdown content can be hidden during the first render. Do not lock it
			// to a 0px height; it will be initialized when the dropdown is shown.
			if (!height && element.offsetHeight === 0 && element.clientHeight === 0) {
				return instances;
			}

			element.__perfectScrollbarState = {
				previousHeight: element.style.height,
				previousOverflowX: element.style.overflowX
			};
			if (height) element.style.height = height;
			element.scrollbarInit = true;
			initializedElements.push(element);

			if (isMobile) {
				element.style.overflowX = 'scroll';
				return instances;
			}

			instances.push(
				new PerfectScrollbar(element, {
					wheelPropagation: element.getAttribute('data-wheel-propagation') === 'true',
					suppressScrollX: true
				})
			);
			return instances;
		},
		[]
	);

	return { instances, initializedElements };
}

export function destroyScrollbars({ instances, initializedElements }) {
	instances.forEach((scrollbar) => scrollbar.destroy());
	initializedElements.forEach((element) => {
		const state = element.__perfectScrollbarState;
		if (state) {
			element.style.height = state.previousHeight;
			element.style.overflowX = state.previousOverflowX;
		}
		delete element.__perfectScrollbarState;
		delete element.scrollbarInit;
	});
}
